import { render, staticRenderFns } from "./ComponentBudget.vue?vue&type=template&id=ec491920&"
import script from "./ComponentBudget.vue?vue&type=script&lang=js&"
export * from "./ComponentBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports